// extracted by mini-css-extract-plugin
module.exports = {"postinfo":"PostInfo-module--postinfo--1TmUA","postinfo__date":"PostInfo-module--postinfo__date--7SC6F"};